"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComplementaryTheme = _interopRequireDefault(require("./ComplementaryTheme"));
var _CaixaSeguradoraTypographyTheme = _interopRequireDefault(require("./CaixaSeguradoraTypographyTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var caixaSeguradoraBaseTheme = {
  name: 'caixa-seguradora',
  version: '1.0.0',
  color: {
    brandPrimary: {
      dark: '#003672',
      medium: '#0039BA',
      light: '#005FC8',
      gradient: 'linear-gradient(215.68deg, #87BAFF -80.44%, #005FC8 81.35%)'
    },
    brandSecondary: {
      dark: '#F36800',
      medium: '#F36800',
      light: '#F36800',
      gradient: 'linear-gradient(224.14deg, #FFA600 -11.69%, #F36800 100%)'
    },
    brandTertiary: {
      dark: '#F36800',
      medium: '#F36800',
      light: '#F36800',
      gradient: 'linear-gradient(224.14deg, #FFA600 -11.69%, #F36800 100%)'
    },
    support: {
      '01': '#F36800',
      '02': '#005FC8',
      '03': '#FFFFFF'
    },
    neutral: {
      '01': '#2D2926',
      '02': '#424242',
      '03': '#6F7C87',
      '04': '#9DAFBD',
      '05': '#D1DBE3',
      '06': '#E9EEF3',
      '07': '#F7F9FA',
      '08': '#FFFFFF'
    },
    feedback: {
      success: '#5B8E00',
      alert: '#E89800',
      error: '#E83131'
    },
    background: {
      dark: '#2D2926',
      light: '#EDF4F6'
    },
    highlight: {
      '01': '#FF715B',
      '02': '#874BCE',
      '03': '#028090',
      '04': '#ED098E',
      '05': '#5465FF',
      '06': '#861657',
      '07': '#AA4131',
      '08': '#606C38'
    },
    line: {
      dark: '#2D2926',
      medium: '#D1DBE3',
      light: '#FFFFFF',
      primary: '#005FC8',
      secondary: '#F36800'
    }
  },
  font: {
    family: {
      highlight: 'Roboto',
      base: 'Roboto'
    },
    size: {
      '2xs': '12px',
      xs: '14px',
      sm: '16px',
      md: '18px',
      lg: '20px',
      xl: '24px',
      '2xl': '28px',
      '3xl': '32px',
      '4xl': '36px',
      '5xl': '40px',
      '6xl': '48px',
      '7xl': '64px'
    },
    weight: {
      '3xs': '100',
      '2xs': '200',
      xs: '300',
      sm: '400',
      md: '500',
      lg: '500',
      xl: '700',
      '2xl': '800',
      '3xl': '900'
    },
    decoration: {
      none: 'none',
      italic: 'italic',
      underline: 'underline',
      strikethrough: 'strikethrough'
    },
    transform: {
      none: 'none',
      uppercase: 'uppercase',
      lowercase: 'lowercase',
      capitalize: 'capitalize'
    }
  },
  line: {
    height: {
      sm: 'auto',
      md: '125%',
      lg: '150%',
      xl: '160%',
      '2xl': '175%',
      '3xl': '200%'
    }
  },
  letter: {
    spacing: {
      sm: 'auto',
      md: '1px',
      lg: '2px',
      xl: '3px',
      '2xl': '4px'
    }
  }
};
var CaixaSeguradoraTheme = _objectSpread(_objectSpread(_objectSpread({}, caixaSeguradoraBaseTheme), (0, _CaixaSeguradoraTypographyTheme["default"])(caixaSeguradoraBaseTheme)), (0, _ComplementaryTheme["default"])(caixaSeguradoraBaseTheme));
var _default = exports["default"] = CaixaSeguradoraTheme;